import React from 'react';
import { HistoryIcon } from 'lucide-react';
import { AuditEntry } from '../../types/commission';
import { Td, Th } from '../sf/DataTable';
export function AuditLogTable({
  entries
}: {
  entries: AuditEntry[];
}) {
  if (entries.length === 0) {
    return <div className="flex flex-col items-center rounded border border-dashed border-sf-border-strong px-6 py-10 text-center" data-id="element-49" data-mp="pjnrprt79qz1">
        <HistoryIcon className="h-6 w-6 text-sf-weak" aria-hidden="true" data-id="element-50" data-mp="3sy03u15u8xur" />
        <p className="mt-2 text-[13px] font-semibold" data-id="element-51" data-mp="3t035jigcsffb">No changes yet</p>
        <p className="mt-1 text-xs text-sf-weak" data-id="element-52" data-mp="3oy98dk5d9tjw">Rule edits saved with a reason appear here.</p>
      </div>;
  }
  return <div className="overflow-hidden rounded border border-sf-border" data-id="element-53" data-mp="6op7abi14rsf">
      <div className="overflow-x-auto" data-id="element-54" data-mp="1qdy82zk6lb9">
        <table className="w-full border-collapse" data-id="element-55" data-mp="1i68hwoxxvx10">
          <thead data-id="element-56" data-mp="1i4njgo8i7txv">
            <tr data-id="element-57" data-mp="1i8bg3w98wwgt">
              <Th data-id="element-58" data-mp="1d747juza3t93">When</Th>
              <Th data-id="element-59" data-mp="1d7nhaoerzbc1">Who</Th>
              <Th data-id="element-60" data-mp="1d6cb6hxuxrhr">Rule Key</Th>
              <Th data-id="element-61" data-mp="1d98bue13au9w">Field</Th>
              <Th data-id="element-62" data-mp="3muzlf33puejc">Old → New</Th>
              <Th data-id="element-63" data-mp="3mtxzu4p2q9nd">Reason</Th>
            </tr>
          </thead>
          <tbody data-id="element-64" data-mp="3rtkcod0zpnvn">
            {entries.map(entry => <tr key={entry.id} data-id="element-65" data-mp="3rrzjaqqewazd">
                <Td className="whitespace-nowrap text-xs tabular-nums text-sf-weak" data-id="element-66" data-mp="nj7gl3phohx">{entry.when}</Td>
                <Td className="whitespace-nowrap" data-id="element-67" data-mp="5mcd5rcr4b7j">{entry.who}</Td>
                <Td className="whitespace-nowrap font-mono text-xs" data-id="element-68" data-mp="5lugwuq39wzm">{entry.ruleKey}</Td>
                <Td className="whitespace-nowrap text-sf-weak" data-id="element-69" data-mp="345t2pg2x9mxj">{entry.field}</Td>
                <Td className="whitespace-nowrap tabular-nums" data-id="element-70" data-mp="394dzf5iytoh8">
                  <span className="text-sf-weak line-through" data-id="element-71" data-mp="3e2patkows71k">{entry.from}</span>
                  <span className="mx-1.5 text-sf-weak" data-id="element-72" data-mp="3e0kxkc54dvom">→</span>
                  <span className="font-semibold" data-id="element-73" data-mp="3iup7n49omjtx">{entry.to}</span>
                </Td>
                <Td className="min-w-[240px]" data-id="element-74" data-mp="2lcywbajd734x">{entry.reason}</Td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}